import { StatCount } from 'shared/model/statistic.model';

type Props = {
  item: StatCount;
};

const TopRevisitTime = ({ item }: Props) => {
  const name = item.name === '0' ? '30 minutes' : item.name + ' hours';

  return (
    <div className="top-config">
      <div>{name}</div>
      <div>{item.count}</div>
    </div>
  );
};

export default TopRevisitTime;
